// extracted by mini-css-extract-plugin
export default {"InfoItem":"InfoItem_InfoItem__Hc5r+","head":"InfoItem_head__jM4Eu"};